"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
const form_login_1 = __importDefault(require("./form-login"));
const login_form_fields_1 = __importDefault(require("./login-form-fields"));
const snap_ui_1 = require("@teamsnap/snap-ui");
const UserCapability_1 = require("core/api/models/UserCapability");
const useAmpli_1 = require("../../../../src/hooks/useAmpli");
const ampli_1 = require("../../../ampli");
const bottom_buttons_1 = __importDefault(require("../bottom-buttons"));
class LoginSettings extends React.Component {
    componentDidMount() {
        ampli_1.ampli?.track({
            event_type: 'Screen Viewed',
            event_properties: { screen_name: useAmpli_1.AmplitudeScreenNames.ACCOUNT_SETTINGS },
        });
    }
    componentWillUnmount() {
        const { showSaveNeeded, dirty, submitting, reset, handleSubmit, history } = this.props;
        if (dirty) {
            const saveNeededData = {
                message: 'You have unsaved log in information changes',
                saving: submitting,
                cancel: reset,
                onSave: handleSubmit(this.onSubmit),
                onSaveError: () => history.replace('/settings/login'),
            };
            return showSaveNeeded(saveNeededData);
        }
    }
    onSubmit = (values) => {
        const { online, submitLoginInformationForm, reset, dirty } = this.props;
        if (online && dirty) {
            return submitLoginInformationForm(values).then(() => {
                reset();
            });
        }
        else {
            // an un-edited form needs to have a clickable button that needs to do nothing.
            // Since it's a form button, onSubmit will be called. We can just return a
            // good promise so the form resolves and sets submitting: false
            return Promise.resolve({});
        }
    };
    render() {
        const { handleSubmit, submitting, reset, isUCIenabled, hasLoginInfoUpdateCapability, user } = this.props;
        const isDisabled = !hasLoginInfoUpdateCapability;
        const userHasTs1 = user?.capabilities?.includes(UserCapability_1.UserCapability.NAVIGATION_GO_TO_TS1);
        return !isUCIenabled ? (React.createElement("form", { id: "login", onSubmit: handleSubmit(this.onSubmit), noValidate: true },
            React.createElement("div", { id: "login-settings", className: "settings-section" },
                React.createElement("div", { id: "profile-info", className: "Panel" },
                    React.createElement("div", { className: "Panel-header" },
                        React.createElement("h3", { className: "Panel-title" }, "Log In Information")),
                    React.createElement("div", { className: "Panel-body" },
                        React.createElement(login_form_fields_1.default, { email: user?.email, disabled: isDisabled, userHasTs1: userHasTs1 }))),
                React.createElement(bottom_buttons_1.default, { id: "login-settings-buttons", submitting: submitting, onCancel: reset, onSubmit: handleSubmit(this.onSubmit), disabled: isDisabled })))) : (React.createElement("form", { id: "login", onSubmit: handleSubmit(this.onSubmit), noValidate: true },
            React.createElement("div", { id: "login-settings", style: { maxWidth: '40rem', margin: 'auto' } },
                React.createElement(form_login_1.default, { disabled: isDisabled }),
                React.createElement("div", { id: "profile-buttons", className: "sui-flex sui-justify-center" },
                    React.createElement(snap_ui_1.LabelButton, { className: "sui-mr-2", variantType: "secondary", labelText: "Cancel", onClick: reset, disabled: isDisabled }),
                    React.createElement(snap_ui_1.LabelButton, { variantType: "primary", labelText: "Save changes", onClick: handleSubmit(this.onSubmit), disabled: isDisabled })))));
    }
}
exports.default = (0, redux_form_1.reduxForm)({
    form: 'login-settings',
    enableReinitialize: true, // to load initialValues
})(LoginSettings);
